<template>
  <div
    class="ff-regular bg-FFFFFF bd-radio-8 h-100 fb fb-main-start fb-cross-center p-0-16"
    @click="handlerClick"
  >
    <div class="face-card-image" :class="type ? 'person' : ''"></div>
    <div class="item-flex-1 pl-16 pr-12">
      <div class="font-34 c-171A1D">{{ title }}</div>
      <div
        class="c-171A1D-40 font-28 mt-4 fb fb-main-start fb-cross-center"
        v-for="(item, index) in centerInfo"
        :key="index"
      >
        <label for="">{{ item.title }}</label>
        <span class="c-006AFE">{{ item.num }}</span>
      </div>
    </div>
    <i class="iconfont font-32 c-171A1D-24">&#xe68d;</i>
  </div>
</template>

<script>
import mixin from '@/mixin'

export default {
  mixins: [mixin],
  props: {
    title: {
      type: String,
      default: '人脸录入管理'
    },
    centerInfo: {
      type: Array,
      default: () => {
        return [
          {
            title: '已录入/全部成员：',
            num: '0/0'
          },
          {
            title: '学生已录入/总数：',
            num: '0/0'
          }
        ]
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    handlerClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.face-card-image {
  height: 56px;
  width: 56px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100%;
  background-image: url('~@/assets/images/face/face-entry.png');
  &.person {
    background-image: url('~@/assets/images/face/face-manage.png');
  }
}
</style>
